import React, { useMemo, useState, useCallback, memo } from 'react';
import { useTranslation } from 'react-i18next';


const NotFound = () => {
    const { t } = useTranslation();
    const tr = useCallback((key) => t(`pageNotFound:${key}`), [t]);

    return (
        <>
            <div className="flex">
                <div className="flex-1 p-4 flex flex-col justify-center items-center h-screen bg-white dark:bg-gray-800">
                    <div className="text-4xl font-bold text-gray-800 dark:text-white mb-4">{tr('pageTitle')}</div>
                    {/* Action to go to previous page */}
                    <div className="text-2xl font-bold text-gray-800 dark:text-white mb-4">{tr('pageDescription')}</div>

                    <button onClick={() => window.history.back()} className="mb-4 px-4 py-2 bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors">
                        {tr('goBack')}
                    </button>
                </div>
            </div>
        </>
    );
};

export default memo(NotFound);
